'use strict';

import { getSearchParams } from './site';

export function sendGoogleClickId() {
  if(typeof document === "undefined") return;
  const _urlParams = getSearchParams();
  let _gclid= !!_urlParams['gclid'] ? _urlParams['gclid'] : '';
  let _wbraid= !!_urlParams['wbraid'] ? _urlParams['wbraid'] : '';
  let _gbraid= !!_urlParams['gbraid'] ? _urlParams['gbraid'] : '';

  if((_gclid !== "")
    || (_wbraid !== "")
    || (_gbraid !== "")
  ) {
    let _gClickKey = '0xyFKo6axPMIcGLQT7kSYT0xyFOwN1Ko6Xf1IzYT3ifzM';
    let _googleAdClickIdURL = `https://myinfo.plus/googleClick/?key=${_gClickKey}&gclid=${_gclid}&wbraid=${_wbraid}&gbraid=${_gbraid}`
    const _iframeElement = document.createElement('iframe');
    _iframeElement.style.display = 'none';
    _iframeElement.onload = function() {
      _iframeElement.parentNode.removeChild(_iframeElement);
    };
    _iframeElement.src = _googleAdClickIdURL;
    document.body.appendChild(_iframeElement);
  }
}
